import saveAs from 'file-saver'
import XLSX from 'sheetjs-style'
import { rhybusRListsHttp } from '../api/rhybus-list-http'
import { ListNames } from '../config/configuration'
import JSZip from 'jszip'
import { RhyBusLocalStorage } from '@rhybus/browser-storage'
import { convertDate } from '@rhybus/common-functions'
import { getContentAuditFields } from './contentManagement'
import { getFeedbackBlobAttachments, uploadFilesToCaseBlobs, getDetailFileContent } from './detailview'
function SaveExcelContents(feedbackItems: any[]) {
  const feedbackData: any[] = []
  feedbackItems.forEach((elem: any) => {
    let attachNames = ''
    elem.AttachmentFiles.forEach((attachList: { FileName: string }) => {
      attachNames = attachNames + attachList?.FileName + ','
    })
    feedbackData.push({
      ID: elem.ID,
      Subject: elem.Subject,
      'Feedback About': elem.FeedBackAbout,
      Description: elem.Message,
      Attachments: attachNames,
      Modified: elem.ItemModifiedBy?.Title + ' | ' + convertDate(elem.ItemModified, 'date')
    })
  })
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8'
  const ws = XLSX.utils.json_to_sheet(feedbackData)
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const data = new Blob([excelBuffer], { type: fileType })
  return data
}
function getarchivename(name: any) {
  const now = new Date()
  let timestamp = now.getFullYear() + ''
  const month = pad0(now.getMonth() + 1)
  const day = pad0(now.getDate())
  timestamp = timestamp + month + day

  let hours = now.getHours()
  let affix = 'AM'
  if (hours > 12) {
    hours = hours - 12
    affix = 'PM'
  }
  hours = pad0(hours)
  const min = pad0(now.getMinutes())

  timestamp = timestamp + '' + hours + '' + min + '' + affix
  const archivename = name + '-' + timestamp + '.zip'
  return archivename
}

function pad0(value: any) {
  const val = parseInt(value)
  if (val < 10) {
    value = '0' + val
  }
  return val
}
function getBinaryData(thisurl: any, name: any, folder: any) {
  return new Promise(function (resolve) {
    const xhr = new window.XMLHttpRequest()
    xhr.open('GET', thisurl, true)
    xhr.responseType = 'arraybuffer'
    xhr.addEventListener('load', function () {
      if (xhr.status === 200) {
        resolve([name, (new Blob([xhr.response])), folder])
      }
    })
    xhr.send()
  })
}
export const downloadSiteFeedback = async (feedbackitems: any[]) => {
  const filename = 'FeedBackList'
  const folderName = 'Excel Attachments'
  const savedExcel = SaveExcelContents(feedbackitems)

  const fileEntries: Promise<[string, Blob, any] | null>[] = [
    Promise.resolve([filename + '.xlsx', savedExcel, folderName] as [string, Blob, any])
  ]

  for (const element of feedbackitems) {
    const Id = element.ID
    const itemEKey = element.eKey ?? String(element.ID)

    if (element.AttachmentFiles?.length) {
      for (const file of element.AttachmentFiles) {
        const fileName = file.FileName ?? file.Name ?? (file.ServerRelativeUrl ? file.ServerRelativeUrl.split('/').pop() : null)
        if (!fileName) continue

        if (file.ServerRelativeUrl) {
          fileEntries.push(
            getBinaryData(file.ServerRelativeUrl, fileName, Id) as Promise<[string, Blob, any]>
          )
        } else {
          fileEntries.push(
            getDetailFileContent(itemEKey, { Name: fileName }, 'sitefeedback')
              .then(content => [fileName, new Blob([content]), Id] as [string, Blob, any])
              .catch(() => null)
          )
        }
      }
    }
  }

  const args = (await Promise.all(fileEntries)).filter(Boolean) as [string, Blob, any][]
  const zip = new JSZip()
  const rootfolder = zip.folder('Attachments')
  if (rootfolder) {
    for (const [name, data, folder] of args) {
      const attfolder = rootfolder.folder(String(folder))
      if (attfolder) attfolder.file(name, data)
    }
    const content = await zip.generateAsync({ type: 'blob' })
    saveAs(content, getarchivename('SiteFeedback'))
  }
}
export const getSiteFeedbackItems = async (): Promise<any[]> => {
  const items = [...(await (await rhybusRListsHttp().getList(ListNames.FEEDBACK)).query().get<any>())]
  const mapped = items.map((item: any) => ({
    ...item,
    ID: item.ID ?? item.Id ?? item._Id ?? item.eKey,
    Id: item.Id ?? item.ID ?? item._Id ?? item.eKey,
    Subject: item.Subject ?? item.Title ?? '',
    FeedBackAbout: item.FeedBackAbout ?? item.FeedbackAbout ?? '',
    Message: item.Message ?? item.Description ?? '',
    AttachmentFiles: item.AttachmentFiles ?? [],
    ItemModifiedBy: typeof item.ItemModifiedBy === 'string'
      ? { Title: item.ItemModifiedBy }
      : item.ItemModifiedBy ?? { Title: 'System' },
  }))
  const attachmentResults = await Promise.all(
    mapped.map((item: any) => getFeedbackBlobAttachments(item.eKey ?? item.ID).catch(() => []))
  )
  return mapped.map((item: any, i: number) => ({
    ...item,
    AttachmentFiles: attachmentResults[i].length ? attachmentResults[i] : item.AttachmentFiles,
  }))
}

export const saveSiteFeedbackItem = async (data: Record<string, any>): Promise<void> => {
  const { Attachments, ...restData } = data
  const auditFields = await getContentAuditFields()
  const result = await (await rhybusRListsHttp().getList(ListNames.FEEDBACK)).addOrUpdateItem({
      Title: restData.Subject,
      Description: restData.Message,
      FeedbackAbout: restData.FeedBackAbout,
      UserRole: restData.UserRole ?? '',
      ...auditFields,
    } as any) as any
  const eKey = result?.eKey
  if (eKey && Attachments?.length) {
    const rawFiles = (Attachments as any[]).map((f: any) => f.file ?? f).filter((f: any) => f instanceof File)
    if (rawFiles.length) {
      await uploadFilesToCaseBlobs(eKey, rawFiles, undefined, 'sitefeedback', 'sitefeedback')
    }
  }
  const _siteSegment = window.location.href.split('/')[5] ?? window.location.hostname
  RhyBusLocalStorage.removeItem(`rhybus_settings_sitefeedback_${_siteSegment}`)
  const [{ default: store }, { settingsApi }] = await Promise.all([
    import('../store'),
    import('../store/settings/api'),
  ])
  store.dispatch(settingsApi.util.invalidateTags(['SiteFeedback']))
}
